import script from "./PasswordManager.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordManager.vue?vue&type=script&setup=true&lang=js"

import "./PasswordManager.vue?vue&type=style&index=0&id=57f1320e&lang=css"

const __exports__ = script;

export default __exports__